module.exports = __webpack_public_path__ + "img/forbes-foo.796687e1.svg";